import { render, staticRenderFns } from "./CourierMobileOrderDetail.vue?vue&type=template&id=14e892b2&scoped=true"
import script from "./CourierMobileOrderDetail.vue?vue&type=script&lang=js"
export * from "./CourierMobileOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./CourierMobileOrderDetail.vue?vue&type=style&index=0&id=14e892b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e892b2",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
